import React from "react";
import CaseListPage from "./CaseListPage";
import { refinementCasesConfig } from "./caseListConfig";
import UpdateCase from "@mods/caseManagement/cases/components/UpdateCase";

/** Refinement rows are editable — the only list where that is true. */
const config = {
  ...refinementCasesConfig,
  onEditComponent: ({ data, onUpdated, onClosed }) => (
    <UpdateCase data={ data } onUpdated={ onUpdated } onClosed={ onClosed } />
  ),
};

const IndexUserRefinementCases = () => <CaseListPage config={ config } />;

export default IndexUserRefinementCases;
